import { WORDS } from '../constants/wordlist'
import { VALID_GUESSES } from '../constants/valid-guesses'

// January 1, 2022 Game Epoch - UTC
const EPOCH_START = 1640995200000
const MS_IN_DAY = 86400000
const OFFSET = new Date().getTimezoneOffset() * 60000

export const isWordInWordList = (word: string) => {
    return WORDS.includes(word.toLowerCase()) || VALID_GUESSES.includes(word.toLowerCase())
}

export const getWordOfDay = (index = -1) => {
    return WORDS[getWordOfDayIndex(index)].toUpperCase()
}

export const isWinningWord = (word: string, index: number) => {
    return getWordOfDay(index) === word
}

export const getWordOfDayIndex = (index = -1) => {
    if (index > -1) {
        return index
    }
    const now = Date.now()
    return Math.floor((now - EPOCH_START - OFFSET) / MS_IN_DAY) % WORDS.length
}

export const getTimeUntilNextWord = (index = -1) => {
    const solutionIndex = getWordOfDayIndex(index)
    return {
        hours: 0,
        minutes: 0,
        seconds: 0,
        solutionIndex: solutionIndex,
    }
}
export type Time = {
    hours: number
    minutes: number
    seconds: number
}

export const formatTime = (time: number) => (time >= 10 ? `${time}` : `0${time}`)
